module.exports = __webpack_public_path__ + "img/h.dd6131d4.jpg";